import { useQuery } from "react-query";
import SkillsReportsService from "./SkillsReportsService";
import { useContext } from "react";
import { AppAuthContext } from "../../../../../core/contexts/AppAuthProvider";

const useSearchUsersBySkill = (skillName) => {
  const { authenticatedUser } = useContext(AppAuthContext);
  const department = authenticatedUser?.department;

  return useQuery(
    ["searchUsersBySkill", skillName, department],
    () => SkillsReportsService.searchUserSkill(skillName, department).then((res) => res.data),
    {
      enabled: !!skillName && !!department,

    }
  );
};

export default useSearchUsersBySkill;
